import { CustomError } from '@geta/kolumbus-frontend/features/common';
import type { TravelCardDto } from "@/types/webapi";

export class TravelCardError extends CustomError {
    card?: TravelCardDto;

    constructor(message: string, card?: TravelCardDto) {
        super('TravelCardError', message);
        this.card = card;
    }
}
